import { ReactElement } from "react";
import { Link } from "react-router-dom";

interface SecondmentsTabsProps {
  secId: number;
  firmId: number;
  active: "view" | "app" | "info";
  posting: boolean;
}

export default function SecondmentsTabs({ secId, firmId, active, posting }: SecondmentsTabsProps): ReactElement {
  function href(action: string): string {
    return `/secondments?action=${action}&secid=${secId}&firm=${firmId}#view`;
  }
  if (!posting) {
    return (
      <nav className="secondments-tabs">
        <span className="is-active">Contact Firm</span>
      </nav>
    );
  }
  return (
    <nav className="secondments-tabs">
      {active === "view" ? <span className="is-active">Overview</span> : <Link to={href("view")}>Overview</Link>}
      {active === "app" ? <span className="is-active">Apply</span> : <Link to={href("app")}>Apply</Link>}
      {active === "info" ? <span className="is-active">Contact Firm</span> : <Link to={href("info")}>Contact Firm</Link>}
    </nav>
  );
}
